import React from 'react';
import { Link } from 'react-router-dom';
// import { Linkedin } from 'react-bootstrap-icons';0
import socLogo from '../assets/soc-logo.svg';
import isoLogo from '../assets/iso-logo-white.svg';
import logo from '../assets/tms-logo.svg';
import LinkedinLogo from '../assets/LinkedIn-logo.png';

const Footer = () => {
    return (
        <footer className="w-full bg-[#090E1B] text-[#090E1B] py-6 px-4 md:px-8">
            <div className="max-w-[1270px] mx-auto flex flex-col gap-6 mb-10">

                {/* Top Section: Logo + Nav Links + LinkedIn Button */}
                <div className="flex flex-col lg:flex-row justify-between items-center gap-6">

                    {/* Left: TMS Logo */}
                    <div className="flex-shrink-0">
                        <img src={logo} alt="TMS" className="h-8 w-auto object-contain" />
                    </div>

                    {/* Center: Navigation Links */}
                    <nav className="flex flex-wrap justify-center gap-6 md:gap-16">
                        <Link to="/" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">Home</Link>
                        <Link to="/features" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">Features</Link>
                        <Link to="/how-it-works" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">How it works</Link>
                        <Link to="/security" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">Security</Link>
                        <Link to="/about-us" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">About Us</Link>
                    </nav>
                </div>

                {/* Divider */}
                <div className="h-[1px] bg-gray-700 w-full"></div>

                {/* Bottom Section: ISO/SOC Logos + Request a Demo */}
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4">

                    {/* Left Side: ISO & SOC Logos */}
                    <div className="flex items-center gap-4">
                        <img src={socLogo} alt="SOC Certified" className="h-12 w-auto" loading="lazy" />
                        <img src={isoLogo} alt="ISO Certified" className="h-12 w-auto" loading="lazy" />
                    </div>

                    {/* Right Side: Request a Demo Button */}
                    <Link
                        to="https://www.linkedin.com/company/fintechglobalcenter/"
                        className="bg-[#0A66C2] hover:bg-[#084d94] text-white font-inter font-semibold text-[16px] px-8 py-3 rounded-[4px] transition-colors"
                    >
                        <img src={LinkedinLogo} alt="LinkedIn" className="h-5 w-auto inline-block mr-2" />
                        Follow us on LinkedIn
                    </Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
